import React from "react";


function category({ category, image }) {
  return (
    <div className="pt-5">
      <div className="flex flex-wrap ">
        <div className="category cards lg:w-[230px] lg:h-[100px] md:w-[230px] md:h-[100px] w-[180px] h-[100px] bg-secondary hover:bg-white transition-all cursor-pointer shadow-lg rounded-md px-2 py-1  items-center flex">
          <div className="flex hover:underline w-[65px] h-[50px] gap-5 items-center">
            <img src={image} alt={category} />
            <p>{category} </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default category;
